__turbopack_context__.v({
  "amount": "EfiAMa_amount",
  "container": "EfiAMa_container",
  "donation": "EfiAMa_donation",
  "message": "EfiAMa_message",
  "noDonations": "EfiAMa_noDonations",
  "seemore": "EfiAMa_seemore",
  "title": "EfiAMa_title",
});
